import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["name", "output"]

    greet() {
        this.outputTarget.textContent = `H3110 ${this.nameTarget.value}!`
    }
}
